var colorSpan = function (sequence, colors) {
    return "Stencil #".concat(sequence, " is ").concat(colors[0].toLowerCase(), " against ").concat(colors[4].toLowerCase());
};
var acrossSpan = function (colors, hasHatches) {
    return "across ".concat(colors[1].toLowerCase(), ", ").concat(colors[2].toLowerCase(), ", and ").concat(colors[3].toLowerCase(), " rotated ").concat(hasHatches ? 'hatched' : 'hatchless', " Stencils");
};
var linearSpan = function (gridLayout) {
    return "".concat(gridLayout.toLowerCase(), "ity");
};
var waveSpan = function (frequency) {
    var absFrequency = Math.abs(frequency);
    return "waves of ".concat(absFrequency < 25
        ? 'negligible'
        : absFrequency < 75
            ? 'low'
            : absFrequency < 125
                ? 'tolerable'
                : absFrequency < 175
                    ? 'high'
                    : 'substantial', " frequency");
};
var cellsSpan = function (cellType, gridLayout, frequency) {
    return "Each cell's ".concat(cellType.toLowerCase(), "ity experiences ").concat(frequency == undefined ? linearSpan(gridLayout) : waveSpan(frequency));
};
var windowSpan = function (windowSize) {
    return "The ".concat(!windowSize ? 'windowless' : "".concat(windowSize < 466 ? 'small' : windowSize < 533 ? 'medium' : 'large', "-windowed"), " Stencil");
};
var solidSpan = function (solidCount) {
    return "contains ".concat(solidCount, " ").concat(solidCount === 1 ? 'solid' : 'solids');
};
var marginSpan = function (marginOffset, solidsInMargin) {
    return marginOffset === 'None'
        ? ''
        : ", ".concat(!solidsInMargin ? 'none' : solidsInMargin, " of which ").concat(solidsInMargin === 1 ? 'is' : 'are', " trapped in the ").concat(marginOffset.toLowerCase(), " margin");
};
export var buildDescription = function (properties) {
    var sequence = properties.sequence, colors = properties.colors, hasHatches = properties.hasHatches, cellType = properties.cellType, gridLayout = properties.gridLayout, frequency = properties.frequency, windowSize = properties.windowSize, solidCount = properties.solidCount, marginOffset = properties.marginOffset, solidsInMargin = properties.solidsInMargin;
    return "".concat(colorSpan(sequence, colors), ", ").concat(acrossSpan(colors, hasHatches), ". ").concat(cellsSpan(cellType, gridLayout, frequency), ". ").concat(windowSpan(windowSize), " ").concat(solidSpan(solidCount)).concat(marginSpan(marginOffset, solidsInMargin), ".");
};
//# sourceMappingURL=descriptions.js.map